export type PrintableEnrollmentToken = {
  title: string;
  code: string;
  qrSvgMarkup: string;
  rows: Array<{ label: string; value: string }>;
  instructions: string;
};

const escapeHtml = (value: string): string =>
  value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/*
  The portal has no print stylesheet, so the code is printed from a minimal
  standalone document. The QR markup is the SVG rendered in the dialog, so what
  prints is exactly what was shown.
*/
export const buildEnrollmentTokenPrintDocument = (token: PrintableEnrollmentToken): string => {
  const rows = token.rows
    .map(row => `<tr><th>${escapeHtml(row.label)}</th><td>${escapeHtml(row.value)}</td></tr>`)
    .join("");

  return `<!doctype html>
<html lang="de">
<head>
<meta charset="utf-8">
<title>${escapeHtml(token.title)}</title>
<style>
  body { font-family: Arial, Helvetica, sans-serif; color: #363652; margin: 40px; }
  h1 { font-size: 22px; margin: 0 0 24px; }
  .code { font-size: 40px; font-weight: 700; letter-spacing: 6px; margin: 16px 0 24px; }
  .qr svg { width: 220px; height: 220px; }
  table { border-collapse: collapse; margin-top: 24px; }
  th { text-align: left; padding: 6px 24px 6px 0; color: #656565; font-weight: 500; }
  td { padding: 6px 0; }
  p { margin-top: 24px; max-width: 560px; line-height: 1.4; }
</style>
</head>
<body>
<h1>${escapeHtml(token.title)}</h1>
<div class="code">${escapeHtml(token.code)}</div>
<div class="qr">${token.qrSvgMarkup}</div>
<table>${rows}</table>
<p>${escapeHtml(token.instructions)}</p>
</body>
</html>`;
};

export const printEnrollmentToken = (token: PrintableEnrollmentToken): boolean => {
  const printWindow = window.open("", "_blank", "width=720,height=900");
  if (!printWindow) return false;

  printWindow.opener = null;
  printWindow.document.open();
  printWindow.document.write(buildEnrollmentTokenPrintDocument(token));
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  return true;
};
